export const formatCurrency = (amount, prefix='$') => {
  return prefix + Number(amount).toFixed(2);
};
